module.exports = __webpack_public_path__ + "static/media/high-none-4.045c74ab.png";